import type { FilterGroup } from '@/types/Filters'

import ky from './httpService'
// import filtersMock from "@/constants/mock/filters.json"

export const getFilters = async (): Promise<Array<FilterGroup>> => {
  const URI = `api/filter`
  const searchParams = new URLSearchParams()
  const filters = await ky.get(URI, { searchParams }).json()
  // return filtersMock as FilterGroup[]
  return filters as FilterGroup[]
}
